import {BaseCachedService} from './Core/BaseCachedService';

class FilterMethodService extends BaseCachedService {
    get Url() { return super.Url + "/filterMethods"; }
}

export const service = new FilterMethodService();

